
import { fetchChatHistory } from '@/api/message'
import {mapActions, mapGetters} from 'vuex'
import {EventBus} from './EventBus'

export const messageMixin = {

  data () {
    return {
      pusher_event_name:''
    }
  },
  computed: {
    ...mapGetters(['ChatRelatedTo', 'UserThreads', 'ClientThreads', 'UserThreadsClass', 'ClientThreadsClass', 'GroupThreads', 'active_thread', 'tabActive', 'UserActiveThread', 'ClientActiveThread', 'GroupActiveThread', 'get_userinfo_data'])
  },
  mounted () {
    // this.generatePusherEventName()
  },
  methods:{
    generatePusherEventName () {
      let event_name = ''
      const customer_id = localStorage.getItem('customer_id')
      const id = this.tabActive === 0 ? this.UserActiveThread : this.tabActive === 1 ? this.ClientActiveThread : this.GroupActiveThread
      if (this.ChatRelatedTo === 1) {
        if (this.tabActive === 0) {
          event_name = `customer_${customer_id}_user_${id}_is_client_message_type_1_type_User`
        } else if (this.tabActive === 1) {
          event_name = `customer_${customer_id}_user_${id}_is_client_message_type_1_type_Client`
        } else if (this.tabActive === 2) {
          event_name = `group_${id}_is_client_message_type_1`
        }
      } else if (this.ChatRelatedTo === 2) {
        if (this.tabActive === 0) {
          event_name = `customer_${customer_id}_user_${id}_is_client_message_type_2_type_User`
        } else if (this.tabActive === 1) {
          event_name = `customer_${customer_id}_user_${id}_is_client_message_type_2_type_Client`
        } else if (this.tabActive === 2) {
          event_name = `group_${id}_is_client_message_type_2`
        }
      } else if (this.ChatRelatedTo === 0) {
        if (this.tabActive === 0) {
          event_name = `customer_${customer_id}_user_${id}_is_client_message_type_0_type_User`
        } else if (this.tabActive === 1) {
          event_name = `customer_${customer_id}_user_${id}_is_client_message_type_0_type_Client`
        } else if (this.tabActive === 2) {
          event_name = `group_${id}_is_client_message_type_0`
        }
      }
      console.log('Generated Pusher Event Name : ', event_name)
      this.pusher_event_name = event_name
    }
   
  }
}